import { displaySymbol } from '../../lib/symbol'

const SHADES = ['#e7e8ea', '#b8babf', '#8a8d94', '#6b6e76', '#4f525a', '#3a3d44', '#2a2c32']

function arc(cx: number, cy: number, r: number, a0: number, a1: number): string {
  const pt = (a: number): [number, number] => [
    cx + r * Math.cos((a * Math.PI) / 180),
    cy + r * Math.sin((a * Math.PI) / 180),
  ]
  const [x1, y1] = pt(a0)
  const [x2, y2] = pt(a1)
  const large = a1 - a0 > 180 ? 1 : 0
  return `M ${x1.toFixed(2)} ${y1.toFixed(2)} A ${r} ${r} 0 ${large} 1 ${x2.toFixed(2)} ${y2.toFixed(2)}`
}

export function AllocationDonut({
  items,
}: {
  items: { symbol: string; weight: number }[]
}) {
  const cx = 120
  const cy = 120
  const r = 92
  const th = 22
  // top semicircle: 180° (left) → 360° (right)
  let acc = 180
  const segs = items
    .filter((i) => i.weight > 0)
    .map((it, i) => {
      const sweep = (it.weight / 100) * 180
      const a0 = acc
      const a1 = acc + sweep
      acc += sweep
      return { ...it, a0, a1, color: SHADES[i % SHADES.length] }
    })

  return (
    <div className="card p-3.5">
      <div className="text-[11px] uppercase tracking-wide text-fg-subtle">Allocation</div>
      <div className="mt-1 flex flex-col items-center gap-3 sm:flex-row">
        <svg viewBox="0 0 240 134" className="w-[200px] shrink-0">
          <path d={arc(cx, cy, r, 180, 360)} fill="none" stroke="var(--color-inset)" strokeWidth={th} />
          {segs.map((s, i) => {
            const gap = Math.min(0.8, (s.a1 - s.a0) / 4)
            return (
              s.a1 - s.a0 > gap * 2 && (
                <path
                  key={i}
                  d={arc(cx, cy, r, s.a0 + gap, s.a1 - gap)}
                  fill="none"
                  stroke={s.color}
                  strokeWidth={th}
                  strokeLinecap="butt"
                />
              )
            )
          })}
        </svg>
        <div className="min-w-0 flex-1 space-y-1">
          {segs.length === 0 ? (
            <div className="text-[12px] text-fg-faint">No holdings.</div>
          ) : (
            segs.map((s, i) => (
              <div key={i} className="flex items-center gap-2 text-[12px]">
                <span className="h-2.5 w-2.5 shrink-0 rounded-sm" style={{ background: s.color }} />
                <span className="font-medium text-fg">{displaySymbol(s.symbol)}</span>
                <span className="num ml-auto text-fg-subtle">{s.weight.toFixed(1)}%</span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  )
}
